import { render, staticRenderFns } from "./CoCardEvent.vue?vue&type=template&id=2d2e4fbb&scoped=true&"
import script from "./CoCardEvent.vue?vue&type=script&lang=ts&"
export * from "./CoCardEvent.vue?vue&type=script&lang=ts&"
import style0 from "./CoCardEvent.vue?vue&type=style&index=0&id=2d2e4fbb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e4fbb",
  null
  
)

export default component.exports